    import moment from 'moment'
	
	export function getNewTime(time)  {
		 let curTime = moment().format('X')
		 let s = moment(time).toDate().getTime() / 1000
		 let diff = curTime - s
		 if (diff < 60) {
		   time = '刚刚'
		 } else if (diff < 60 * 60) {
		   time = Math.floor(diff / 60) + '分钟前'
		 } else if (diff < 60 * 60 * 24) {
		   time = Math.floor(diff / (60 * 60)) + '小时前'
		 } else if (diff < 60 * 60 * 24 * 3) {
		   let t = diff / (60 * 60 * 24)
		   if (t == 1) {
			 time = '昨天'
		   } else {
			 time = '前天'
		   }
		 } else {
		   time = moment(time).format('YYYY-MM-DD HH:mm')
		 }
		 return time
	 }
	 
	export function randomString(len) {
  　　len = len || 32;
  　　var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    
  　　var maxPos = $chars.length;
  　　var pwd = '';
  　　for (var i = 0; i < len; i++) {
  　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  　　}
  　　return pwd;
	 }


// WEBPACK FOOTER //
// ./src/utils/utils.js